import { Command } from 'commander'

import { apiService } from '@/helpers'
import { output } from '@/helpers/std-out'

export const DeleteCommand = () => {
  const cmd = new Command('delete')

  cmd.description('Delete a document from scalar registry')
  cmd.argument('[namespace]', 'Team namespace')
  cmd.argument('[slug]', 'Managed doc slug')

  cmd.action(async (namespace, slug) => {
    const client = await apiService()

    const logger = output.info().line().loader('Deleting the api document')
    const deleteDocument = await client.managedDocs.delete(namespace, slug)

    if (deleteDocument.error) {
      return output.error().title(deleteDocument.message).exit('error')
    }

    // Display success message
    logger
      .update('loader', 0, { content: 'Successfully deleted document.' })
      .print()
  })

  return cmd
}
